import {
    type GetMyOpportunitiesResponseType,
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const GetMyOpportunities = async (): Promise<GetMyOpportunitiesResponseType> => {
    return await axios(`${SERVER_ADDRESS}/profile/getMyOpportunities`, {
        method: "GET",
        headers: getHeaders(true)
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default GetMyOpportunities;
